import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Form as FinalForm } from 'react-final-form';
import { v4 as uuidV4 } from 'uuid';

// Global Types
import { AppState } from 'services/types';

// Global Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import { addMyTimesheetEntry } from 'services/myTimesheetEntries/actions';

// Global Form
import { myTimesheetEntryDecorator } from 'forms/decorators';
import { validateTimesheetEntry } from 'forms/validate';

// Local Components
import MyTimesheetEntryForm from './components/MyTimesheetEntryForm';

// Local Selectors
import { selectInitialValues } from './selectors';

// Local Constants
import { QUERY_STRING_PARAM } from '../../constants';

interface ConnectedProps {
    initialValues: Record<string, any>;
}

interface DispatchProps {
    addMyTimesheetEntry: (values: any) => any;
    updateQueryString: Function;
}

interface OwnProps {
    personId: number;
}

type Props = ConnectedProps & DispatchProps & OwnProps;

export class MyTimesheetEntryFinalForm extends React.PureComponent<Props> {
    handleSubmit = (values: any): void => {
        this.props.addMyTimesheetEntry({
            ...values,
            uuid: values.uuid || uuidV4()
        });

        this.props.updateQueryString({
            [QUERY_STRING_PARAM]: undefined
        });
    };

    render(): React.ReactElement {
        const { initialValues, personId } = this.props;

        return (
            <FinalForm
                onSubmit={this.handleSubmit}
                component={MyTimesheetEntryForm as any}
                subscription={{}}
                decorators={[myTimesheetEntryDecorator]}
                initialValues={initialValues}
                validate={validateTimesheetEntry}
                personId={personId}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    initialValues: selectInitialValues
});

export default connect(mapStateToProps, {
    addMyTimesheetEntry,
    updateQueryString
})(MyTimesheetEntryFinalForm);
